import {
  Instagram,
  Youtube,
  Facebook,
  Linkedin,
  Twitter,
  Hash,
  PinIcon,
  Video,
} from "lucide-react";
import { cn } from "@/lib/utils";

const PLATFORM_CONFIG: Record<string, { icon: React.ElementType; className: string; label: string }> = {
  INSTAGRAM: { icon: Instagram, className: "text-pink-400", label: "Instagram" },
  TIKTOK: { icon: Video, className: "text-zinc-300", label: "TikTok" },
  FACEBOOK: { icon: Facebook, className: "text-blue-400", label: "Facebook" },
  YOUTUBE: { icon: Youtube, className: "text-red-400", label: "YouTube" },
  LINKEDIN: { icon: Linkedin, className: "text-blue-500", label: "LinkedIn" },
  TWITTER: { icon: Twitter, className: "text-sky-400", label: "Twitter" },
  THREADS: { icon: Hash, className: "text-zinc-300", label: "Threads" },
  PINTEREST: { icon: PinIcon, className: "text-red-500", label: "Pinterest" },
};

export function PlatformIcon({
  platform,
  size = 16,
  className,
}: {
  platform: string;
  size?: number;
  className?: string;
}) {
  const config = PLATFORM_CONFIG[platform];
  if (!config) return null;
  const Icon = config.icon;
  return <Icon size={size} className={cn(config.className, className)} />;
}

export function getPlatformLabel(platform: string): string {
  return PLATFORM_CONFIG[platform]?.label ?? platform;
}
